import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-printable-entry-account-statement',
  templateUrl: './printable-entry-account-statement.component.html',
styleUrls:  ['./printable-entry-account-statement.component.css']
})
export class PrintableEntryAccountStatementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
